import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, XCircle } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ['Intentas usar la lógica cuando tu cerebro está inundado de cortisol y adrenalina.', 'Silencias sus redes en lugar de bloquear, dejando la puerta abierta a la recaída.', 'No tienes un plan de respuesta para cuando te escribe, y terminas cediendo por culpa.', 'Confundes la "necesidad de cierre" con la necesidad de una dosis de atención.', 'Escuchas a amigos que te dicen "dale tiempo", cuando lo que necesitas es un protocolo de choque.'];
  return <section className="py-24 relative border-t border-white/5 pt-[10px] pb-[10px]" data-id="element-143">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-lg md:text-xl text-brand-gray leading-relaxed mb-20 space-y-[32px]" data-id="element-145">
          <p data-id="element-146">
            Seguro que ya te lo han dicho:{' '}
            <span className="text-brand-white font-medium" data-id="element-147">
              "Solo tienes que dejar de escribirle"
            </span>
            . Pero nadie te explica qué hacer cuando la ansiedad te oprime el
            pecho, cuando el impulso de revisar sus historias de Instagram es
            más fuerte que tu voluntad, o cuando un simple "hola" de su parte
            destruye semanas de progreso.
          </p>
          <p data-id="element-148">
            El contacto cero tradicional falla porque trata la ruptura como un
            drama sentimental, cuando en realidad es una{' '}
            <span className="text-brand-red font-semibold" data-id="element-149">
              adicción biológica
            </span>
            . Tu cerebro está pidiendo una dosis de dopamina que solo esa
            persona le daba, y cada vez que "stalkeas", te inyectas veneno
            creyendo que es medicina.
          </p>
          <div className="p-6 border-l-2 border-brand-gold bg-brand-gold/5 rounded-r-lg mt-8" data-id="element-150">
            <p className="text-brand-white font-medium italic" data-id="element-151">
              CeroRastro™ no es un libro de consejos románticos. Es un sistema
              de defensa.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="space-y-[16px]" data-id="element-152">
          <div className="flex items-center gap-3 mb-10" data-id="element-153">
            <AlertCircle className="w-8 h-8 text-brand-red" data-id="element-154" />
            <h2 className="text-2xl md:text-3xl font-bold text-brand-white uppercase tracking-wide" data-id="element-155">
              Por qué todo lo que has intentado ha fallado:
            </h2>
          </div>

          <div className="space-y-4" data-id="element-156">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4 p-5 rounded-xl bg-brand-dark border border-white/5 hover:border-brand-red/30 transition-colors" data-id="element-157">
                <XCircle className="w-6 h-6 text-brand-red shrink-0 mt-0.5" data-id="element-158" />
                <p className="text-brand-gray" data-id="element-159">{point}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}